import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ZuweisungService {
    private http = inject(HttpClient);

    public countZugewiesenAndNotGelesen(orgId: string): Promise<number> {
        return this.http.get(environment.API_URL + '/zuweisung/' + orgId + '/zugewiesenAndNotGelesen').toPromise() as Promise<number>;
    }
}
